"use strict";
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = require("react");
var nodes = new Map();
var updateQueued = false;
function updateFontSize() {
    updateQueued = true;
    Array.from(nodes, function (_a) {
        var _b = __read(_a, 2), element = _b[0], options = _b[1];
        return ({
            element: element,
            options: options
        });
    }).forEach(function (x) {
        var minimumDimension = Math.min(x.element.offsetWidth, x.element.offsetHeight);
        x.element.style.fontSize = Math.min(Math.max(minimumDimension / (x.options.compressor * 10), x.options.minFontSize), x.options.maxFontSize) + "px";
    });
}
var ReactFitText = function (props) {
    var childRef = undefined;
    react_1.useEffect(function () {
        window.addEventListener("resize", updateFontSize);
        window.addEventListener("load", updateFontSize);
        return function () {
            if (childRef) {
                nodes.delete(childRef);
            }
            window.removeEventListener("resize", updateFontSize);
            window.removeEventListener("load", updateFontSize);
        };
    }, [window]);
    react_1.useEffect(function () {
        if (!updateQueued && typeof window !== "undefined") {
            window.requestAnimationFrame(updateFontSize);
        }
    }, [updateQueued, window]);
    updateFontSize();
    return react_1.Children.map(props.children, function (child) {
        return react_1.cloneElement(child, {
            ref: function (element) {
                if (element) {
                    nodes.set(element, props);
                }
                childRef = element;
            }
        });
    })[0];
};
ReactFitText.defaultProps = {
    compressor: 1.0,
    minFontSize: Number.NEGATIVE_INFINITY,
    maxFontSize: Number.POSITIVE_INFINITY
};
exports.default = ReactFitText;
